/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BorrowerQuoteTabDto
 */
export interface BorrowerQuoteTabDto {
    /**
     * Quote ID associated with this borrower
     * @type {string}
     * @memberof BorrowerQuoteTabDto
     */
    quoteId: string;
    /**
     * Borrower ID
     * @type {string}
     * @memberof BorrowerQuoteTabDto
     */
    borrowerId: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerQuoteTabDto
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerQuoteTabDto
     */
    borrowerName?: string;
    /**
     * 
     * @type {number}
     * @memberof BorrowerQuoteTabDto
     */
    clientPrice?: number;
    /**
     * Product name
     * @type {string}
     * @memberof BorrowerQuoteTabDto
     */
    product?: string;
}

/**
 * Check if a given object implements the BorrowerQuoteTabDto interface.
 */
export function instanceOfBorrowerQuoteTabDto(value: object): value is BorrowerQuoteTabDto {
    if (!('quoteId' in value) || value['quoteId'] === undefined) return false;
    if (!('borrowerId' in value) || value['borrowerId'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function BorrowerQuoteTabDtoFromJSON(json: any): BorrowerQuoteTabDto {
    return BorrowerQuoteTabDtoFromJSONTyped(json, false);
}

export function BorrowerQuoteTabDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerQuoteTabDto {
    if (json == null) {
        return json;
    }
    return {
        
        'quoteId': json['quoteId'],
        'borrowerId': json['borrowerId'],
        'label': json['label'],
        'borrowerName': json['borrowerName'] == null ? undefined : json['borrowerName'],
        'clientPrice': json['clientPrice'] == null ? undefined : json['clientPrice'],
        'product': json['product'] == null ? undefined : json['product'],
    };
}

export function BorrowerQuoteTabDtoToJSON(json: any): BorrowerQuoteTabDto {
    return BorrowerQuoteTabDtoToJSONTyped(json, false);
}

export function BorrowerQuoteTabDtoToJSONTyped(value?: BorrowerQuoteTabDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'quoteId': value['quoteId'],
        'borrowerId': value['borrowerId'],
        'label': value['label'],
        'borrowerName': value['borrowerName'],
        'clientPrice': value['clientPrice'],
        'product': value['product'],
    };
}

